import { InboxData, InboxStatus } from '../inboxViewSlice/types';

export const data: InboxData = {
  inboxes: [
    {
      id: '1',
      title: 'תיבת דואר ראשית',
      status: InboxStatus.Active,
      source: {
        type: 'GMAIL',
        img: 'https://cdn.iconscout.com/icon/free/png-512/free-gmail-logo-icon-download-in-svg-png-gif-file-formats--mail-email-logos-icons-2416660.png?f=webp&w=512',
      },
      address: 'tomerlevi.g@gmail.com',
      creation_date: '2024-02-17T00:00:00.000',
      last_sync_date: '2025-03-20T00:00:00.000',
      receipts_count: 293,
      tags: ['עבודה', 'אישי'],
    },
    {
      id: '2',
      title: 'תיבת דואר משנית',
      status: InboxStatus.Active,
      source: {
        type: 'GMAIL',
        img: 'https://cdn.iconscout.com/icon/free/png-512/free-gmail-logo-icon-download-in-svg-png-gif-file-formats--mail-email-logos-icons-2416660.png?f=webp&w=512',
      },
      address: 'tomerlevi.g_2@gmail.com',
      creation_date: '2024-02-20T00:00:00.000',
      last_sync_date: '2025-03-20T00:00:00.000',
      receipts_count: 293,
      tags: ['עבודה', 'אישי'],
    },
  ],
};
